$('.new-featured-collection').slick({
centerMode: false,
centerPadding: '00px',
slidesToShow: 4,
arrows: true,
dots: false,
  gap:10,
infinite: false,  
autoplay:false,
autoplaySpeed:2500,  
responsive: [
{
breakpoint: 1200,
settings: {
arrows: true,
dots: false,
centerMode: false,
centerPadding: '0px',
slidesToShow: 3
}
},
{
breakpoint: 990,
settings: {
arrows: true,
dots: false,
centerMode: false,
centerPadding: '0px',
slidesToShow: 2
}
},  
{
breakpoint: 750,
settings: {
arrows: false,
dots: false,
centerMode: false,
centerPadding: '0px',
slidesToShow: 1.30
}
}
]
});